import { makeAutoObservable, runInAction } from 'mobx';
import agent from '../api/agent';
import { Activity } from '../models/activity';

export default class clonedStore {
  cloneRegistry = new Map<string, Activity>();
  selectedClone: Activity | undefined = undefined;
  loadingInitial = false;
  loading = false;
  selectedActivity: Activity | undefined = undefined;
  clonedItems: any = [];
  userItems: any = [];
  sectionClonedItems: any[] = [];
  sectionMultipleItems: any[] = [];
  existingData: string[] = [];
  constructor() {
    makeAutoObservable(this);
  }
  get cloneitemsByDate() {
    return Array.from(this.cloneRegistry.values());
  }
  setLoadingInitial = (state: boolean) => {
    this.loadingInitial = state;
  };
  private setClone = (activity: Activity) => {
    this.cloneRegistry.set(activity.id, activity);
  };

  CheckUserById = async (id: string) => {
    this.loadingInitial = true;
    try {
      const ClonedComponent = await agent.Reports.CheckUser(id);
      runInAction(() => {
        this.userItems = ClonedComponent;
      });
      this.setLoadingInitial(false);
      // return ClonedComponent;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };
  loadComponentById = async (id: string) => {
    this.loadingInitial = true;
    try {
      const ClonedComponent = await agent.Reports.details(id);
      runInAction(() => {
        this.clonedItems = ClonedComponent;
      });
      this.setLoadingInitial(false);
      return ClonedComponent;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };
  loadSectionById = async (id: string) => {
    this.loadingInitial = true;
    try {
      // const ClonedComponent = await agent.Reports.sectiondetails(id);
      const ClonedComponent2 = await agent.Reports.sectionMultipledetails(id);
      const id1 = id.split('/')[0];
      const ClonedComponent3 = await agent.Reports.linkExisting(id1);
      runInAction(() => {
        this.sectionClonedItems = [];
        let newArr: any = [];

        ClonedComponent2.forEach((x) => {
          newArr.push(x);
        });
        ClonedComponent3.forEach((x) => {
          newArr.push(x);
          this.existingData.push(x.id);
        });

        const ids = newArr.map((o: any) => o.id);
        const filtered = newArr.filter(
          ({ id }: { id: string }, index: number) =>
            !ids.includes(id, index + 1),
        );
        this.sectionClonedItems = filtered;
      });
      this.setLoadingInitial(false);
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };
  loadSectionMultipleById = async (id: string) => {
    this.loadingInitial = true;
    try {
      const ClonedComponent = await agent.Reports.sectionMultipledetails(id);
      runInAction(() => {
        this.sectionMultipleItems = ClonedComponent;
      });
      this.setLoadingInitial(false);
      return ClonedComponent;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };
}
